export { default } from './FormattedText';
